const LOCALE = "ar-SA-u-ca-gregory-nu-latn";

export const timeOf = (iso) => (iso ? new Date(iso).toLocaleTimeString(LOCALE, { hour: "2-digit", minute: "2-digit" }) : "");

export const dayLabel = (iso) => {
  if (!iso) return "";
  const d = new Date(iso), now = new Date();
  const same = (a, b) => a.toDateString() === b.toDateString();
  if (same(d, now)) return "اليوم";
  const y = new Date(now); y.setDate(now.getDate() - 1);
  if (same(d, y)) return "أمس";
  return d.toLocaleDateString(LOCALE, { day: "numeric", month: "long", year: d.getFullYear() === now.getFullYear() ? undefined : "numeric" });
};

// آخر نشاط في قائمة الدردشات: وقت اليوم، «أمس»، أو التاريخ المختصر
export const listTime = (iso) => {
  if (!iso) return "";
  const l = dayLabel(iso);
  if (l === "اليوم") return timeOf(iso);
  if (l === "أمس") return l;
  return new Date(iso).toLocaleDateString(LOCALE, { day: "2-digit", month: "2-digit" });
};

export const initials = (c) => ((c?.name || "").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("") || "#");

const HUES = [152, 199, 262, 24, 330, 48, 180, 290];
export const avatarHue = (id = "") => HUES[[...String(id)].reduce((a, ch) => a + ch.charCodeAt(0), 0) % HUES.length];

export const mediaSrc = (url) => (!url ? null : url.startsWith("http") || url.startsWith("data:") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);
